import { Loader2 } from 'lucide-react'
import { cn } from '@/shared/utils'
export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('animate-spin text-brand-500', className)} size={24} />
}
export function PageSpinner() {
  return <div className="flex items-center justify-center h-64"><Spinner className="w-8 h-8" /></div>
}
